import { Route, Routes } from 'react-router-dom'
import * as React from 'react'
import AddContainerSample from '../../../Pages/Sample/AddAnimal/AddContainerSample'
import AddAnimalSamples from '../../../Pages/Sample/AddAnimal/AddAnimalSamples'
import AddEnvironmentSample from '../../../Pages/Sample/AddAnimal/AddEnvironmentSample'
import AddRackSample from '../../../Pages/Sample/AddAnimal/AddRackSample'
import NotFound from '../../NotFound'

function AddSampleRouter() {
  return (
    <Routes>
      <Route
        index
        element={<AddAnimalSamples qty={'boolean'} />}
      />
      <Route
        path="animal"
        element={<AddAnimalSamples qty={'boolean'} />}
      />
      <Route
        path="storage"
        element={<AddAnimalSamples qty={'multiple'} />}
      />
      <Route
        path="environment"
        element={<AddEnvironmentSample />}
      />
      <Route
        path="rack"
        element={<AddRackSample />}
      />
      <Route
        path="container"
        element={<AddContainerSample />}
      />
      <Route
        path="*"
        element={<NotFound />}
      />
    </Routes>
  )
}

export default AddSampleRouter
